const certificates = [
    {
        type: "oracle",
        imageLink: "/certificates-avatar/oracle.jpg",
        name: "Oracle Cloud Infrastructure Foundation Associate 2025",
        source: "Oracle",
        links: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=180747B31B3F109E9FB6771B9F399913B83CEB6B1A15FF2E05A2F197B9696311"
    }, 
    {
        type: "google",
        imageLink: "/certificates-avatar/google.png",
        name: "Foundations of User Experience (UX) Design",
        source: "Google",
        links: "https://www.coursera.org/account/accomplishments/verify/CVFBLRA9VKE4"
    }, 
    {
        type: "googleCloud",
        imageLink: "/certificates-avatar/google-cloud.png",
        name: "Google Cloud Fundamentals: Core Infrastructure",
        source: "Google Cloud",
        links: "https://www.coursera.org/account/accomplishments/verify/F0RS2SDWR7S2"
    }, 
    {
        type: "google",
        imageLink: "/certificates-avatar/google.png",
        name: "Google AI Essentials V1",
        source: "Google",
        links: "https://www.credly.com/badges/9d482d25-40a3-43f8-b480-12322cac48a0/linked_in_profile"
    }, 
    {
        type: "hpe",
        imageLink: "/certificates-avatar/hpe.png",
        name: "Software Engineering Job Simulation",
        source: "Hewlett Packard Enterprise (HPE)",
        links: "https://www.theforage.com/completion-certificates/fgHAi6dLhpRsGKyyN/da2T3WZCbMAJD7bNB_fgHAi6dLhpRsGKyyN_XNdHZECk24vK9ErcM_1755986432607_completion_certificate.pdf"
    },
    {
        type: "forage",
        imageLink: "/certificates-avatar/jpmorganchase.png",
        name: "Software Engineering Job Simulation",
        source: "J.P. Morgan Chase & CO",
        links: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/J.P.%20Morgan/R5iK7HMxJGBgaSbvk_J.P.%20Morgan_XNdHZECk24vK9ErcM_1722588944780_completion_certificate.pdf"
    },
    
    {
        type: "freeCodeCamp",
        imageLink: "/certificates-avatar/freeCodeCamp.jpg",
        name: "Back End Development and APIs",
        source: "freeCodeCamp",
        links: "https://freecodecamp.org/certification/fcc719b8d1f-12da-4b61-bb11-3a319c1eb456/back-end-development-and-apis"
    },
    {
        type: "codepathT",
        imageLink: "/certificates-avatar/codepath.png",
        name: "Advanced Web Development",
        source: "CodePath",
        links: "/certificates/WEB103.pdf"
    },
    {
        type: "codepathW",
        imageLink: "/certificates-avatar/codepath.png",
        name: "Advanced Technical Interview Prep",
        source: "CodePath",
        links: "/certificates/TIP103.pdf"
    },
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Apache Kafka Essential Training: Getting Started",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/3f5fa8c58b2bbd0297093e5579a23e4f9030a44459d86991480536eaa77f4093"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Kubernetes: Essential Tools",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/2bef534bd6d811c24e5f095587ce653f7b11b37076be6d6b39e561255af08851"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Learning Docker",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/9b67440ad0d50d1385f6c3a892e312e70bc7329c538f9fac684ec1691d73bbb5"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Learning Kubernetes",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/8a5d817b07cd9631ea6fd0cdc8eb263135e7dd0512b98e003de84989307500b5"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Learning Next.js",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/db7575952107615c8bc0f4645a8fd06cff864c07b8bf170feedab337cf289013"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Node.js Essential Training",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/0cdfbe5374f7dae8ad47175e64a3b1bac651c399972282b0fbec77682da227c4"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Angular Essential Training",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/9577f2ec00de723699d64deb296f993ca5b76cc22ecca309c76601523a60d53e"
    }, 
    {
        type: "hackerRank",
        imageLink: "/certificates-avatar/hackerrank.png",   
        name: "Frontend Developer (React)",
        source: "HackerRank",
        links: "https://www.hackerrank.com/certificates/9352e5eb1d81"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Git Essential Training",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/400f1b3ed8e57dd7e60725b8cc12e9af7bd869ce2cd60cccacbd39910f90b543"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "React: Creating and Hosting a Full-Stack Site",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/a778c7706aba847c20defd5a0c41f69e0a932491661576e3a0e4568de0072683"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Vue.js: Creating and Hosting a Full-Stack Site",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/8f61fb1038be956851ef465fb9c815e896a4b21034108ba0a90323cc460e3f3d"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "Learning MySQL Development",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/8c20af20cab12b9d2512e630de9b7c86bf650f4afa685eae12d6a2af81dfc82a"
    }, 
    {
        type: "linkedIn",
        imageLink: "/certificates-avatar/linkedin.png",
        name: "React.js Essential Training",
        source: "LinkedIn",
        links: "https://www.linkedin.com/learning/certificates/746ded1ca4bdf54584bf465b2cc71f69a8fd6e2f96b9862b8e0dd95c5b07fcb8"
    }, 
]

export default certificates;